
import Loading from '@/components/Loading.vue'
import ProductSliderListItem from '@/components/ProductSliderListItem'

export default {
  name: 'ProductSliderList',
  components: { ProductSliderListItem, Loading },

  props: {
    itemsPerSlide: {
      type: Number,
      default: 4,
    },
    showBestSatesFirst: {
      default: false,
      type: Boolean,
    },
    showNewestsFirst: {
      default: false,
      type: Boolean,
    },
    isFromSlider: {
      default: false,
      type: Boolean,
    },
    productMaxWidth: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      products_discounts_list: [],
      products_best_sells_list: [],
      products_best_sells_loading: true,
      products_news_list_loading: true,
      products_best_rated_loading: true,
      products_discounts_loading: true,
      products_news_list: [],
      products_best_rated: [],
    }
  },

  computed: {
    categoryRef() {
      return this.$route.params.category || this.$route.params.domain || null
    },
  },

  async fetch() {
    if (this.showBestSatesFirst) {
      await this.getBestSales()
    }
  },

  mounted() {
    if (!this.showBestSatesFirst && !this.showNewestsFirst) {
      this.getDiscounts()
    }
    if (this.showNewestsFirst) {
      this.getNewests()
    }
  },

  methods: {
    fetchInCategoryOrShop(fetchInCategory, fetchInShop) {
      if (!this.categoryRef) {
        return fetchInShop()
      }

      return fetchInCategory(this.categoryRef).catch(error => {
        if (error?.response?.status === 404) {
          return fetchInShop()
        }
        throw error
      })
    },

    async getBestSales() {
      if (this.products_best_sells_list.length === 0) {
        const fetchPromise = this.fetchInCategoryOrShop(
          this.$productService.fetchCategoryPageBestSales,
          this.$productService.fetchProductsBestSales
        )
        await fetchPromise.then(({ data }) => {
          this.products_best_sells_list = data
          this.products_best_sells_loading = false
        })
      }
    },

    getNewests() {
      if (this.products_news_list.length === 0) {
        const fetchPromise = this.fetchInCategoryOrShop(
          this.$productService.fetchCategoryPageNewest,
          this.$productService.fetchProductsNewest
        )
        fetchPromise.then(({ data }) => {
          this.products_news_list = data
          this.products_news_list_loading = false
        })
      }
    },
    getBestRated() {
      if (this.products_best_rated.length === 0) {
        const fetchPromise = this.fetchInCategoryOrShop(
          this.$productService.fetchCategoryPageBestRated,
          this.$productService.fetchProductsBestRated
        )
        fetchPromise.then(({ data }) => {
          this.products_best_rated = data
          this.products_best_rated_loading = false
        })
      }
    },
    getDiscounts() {
      const fetchPromise = this.fetchInCategoryOrShop(
        this.$productService.fetchCategoryPageDiscounts,
        this.$productService.fetchProductsDiscounts
      )
      fetchPromise.then(({ data }) => {
        this.products_discounts_list = data
        this.products_discounts_loading = false
      })
    },
  },
}
